<template>
  <v-data-table :headers="headers" :items="evaluaciones" :items-per-page="10" class="elevation-1">
    <template v-slot:[`item.id`]="{ item }">
      {{ item.idProductividad || item.idRespetoPrincipios }}
    </template>

    <template v-slot:[`item.fechaAplicacion`]="{ item }">
      {{ getFormattedDate(item.fechaAplicacion) }}
    </template>

    <template v-slot:[`item.evaluado`]="{ item }">
      {{
        `${item.Evaluado[0].Nombre} ${item.Evaluado[0].segundoNombre} ${item.Evaluado[0].apaterno} ${item.Evaluado[0].amaterno}`
      }}
    </template>

    <template v-slot:[`item.estatus`]="{ item }">
      <v-chip :color="getStatusColor(item.estatus)" text-color="white" small>
        {{ item.estatus }}
      </v-chip>
    </template>

    <template v-slot:[`item.opciones`]="{ item }">
      <v-btn
        icon
        small
        color="warning"
        @click="$emit('edit-evaluation', item)"
        title="Editar evaluación"
        :disabled="item.estatus === 'Finalizada'"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    evaluaciones: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {
          text: 'Fecha de aplicación',
          align: 'start',
          value: 'fechaAplicacion',
        },
        {
          text: 'Evaluado',
          align: 'start',
          value: 'evaluado',
        },
        {
          text: 'CUIP',
          value: 'Evaluado[0].CUIP',
        },
        {
          text: 'Estatus de evaluación',
          value: 'estatusEvaluacion',
        },
        {
          text: 'Opciones',
          value: 'opciones',
          sortable: false,
          align: 'center',
        },
      ],
    }
  },

  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Pendiente':
          return 'orange'
        case 'En proceso':
          return 'blue'
        case 'Finalizada':
          return 'green'
        case 'Cancelada':
          return 'red'
        default:
          return 'grey'
      }
    },

    getFormattedDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(dateString).toLocaleDateString('es-MX', options)
    },
  },
}
</script>
